import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { InventoryManagerListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestUpdateManagerStatus = async ({
  managerId,
  isActive
}: {
  managerId: string;
  isActive: boolean;
}): Promise<InventoryManagerListItem> => {
  return await instance.put(
    buildUrl(
      ApiRoutesInventory.InventoryManagerActiveStatus,
      managerId,
      String(isActive)
    )
  );
};
